// Overgezet uit naslag/server/imports/api/types/randomizers.ts.
export var DieOption;
(function (DieOption) {
    DieOption["red"] = "red";
    DieOption["yellow"] = "yellow";
    DieOption["green"] = "green";
})(DieOption || (DieOption = {}));
